module.exports = __webpack_public_path__ + "assets/img/Infringements.77b936fa.jpg";